/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventViewModel } from './EventViewModel';
import {
    EventViewModelFromJSON,
    EventViewModelFromJSONTyped,
    EventViewModelToJSON,
} from './EventViewModel';

/**
 * 
 * @export
 * @interface EventsViewModel
 */
export interface EventsViewModel {
    /**
     * 
     * @type {Array<EventViewModel>}
     * @memberof EventsViewModel
     */
    events: Array<EventViewModel>;
}

/**
 * Check if a given object implements the EventsViewModel interface.
 */
export function instanceOfEventsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "events" in value;

    return isInstance;
}

export function EventsViewModelFromJSON(json: any): EventsViewModel {
    return EventsViewModelFromJSONTyped(json, false);
}

export function EventsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': ((json['Events'] as Array<any>).map(EventViewModelFromJSON)),
    };
}

export function EventsViewModelToJSON(value?: EventsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Events': ((value.events as Array<any>).map(EventViewModelToJSON)),
    };
}

